"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shader = _interopRequireDefault(require("./shader"));

//highlight blue
var blueBase = '#006FE8';
var highlightblue = {
  dark40: (0, _shader["default"])(-0.4, blueBase),
  //#000E1C
  dark30: (0, _shader["default"])(-0.3, blueBase),
  //#00264F
  dark20: (0, _shader["default"])(-0.2, blueBase),
  //#003F82
  dark10: (0, _shader["default"])(-0.1, blueBase),
  //#0057B5
  base: blueBase,
  light10: (0, _shader["default"])(0.1, blueBase),
  //#1C89FF
  light20: (0, _shader["default"])(0.2, blueBase),
  //#4FA4FF
  light30: (0, _shader["default"])(0.3, blueBase),
  //#82BEFF
  light40: (0, _shader["default"])(0.4, blueBase),
  //#B5D9FF
  light45: (0, _shader["default"])(0.45, blueBase) //#CFE6FF

};
var _default = highlightblue;
exports["default"] = _default;